exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tooltip {\n  max-width: 60%; }\n\n.ant-tree-node-content-wrapper-normal {\n  overflow: hidden;\n  display: block;\n  text-overflow: ellipsis; }\n\n#components-table-drag-sorting tr.drop-over-downward td {\n  border-bottom: 2px dashed #1890ff; }\n\n#components-table-drag-sorting tr.drop-over-upward td {\n  border-top: 2px dashed #1890ff; }\n\n.Select-menu-outer {\n  z-index: 500; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/client/styles/styles.css
// module id = 3305
// module chunks = 0